import styles from './UpcomingHolidaysSection.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import UpcomingDataCard from '../../components/UpcomingDataCard/UpcomingDataCard';
import { PiHouseSimpleBold } from 'react-icons/pi';
import { NavLink } from 'react-router';
// import HolidayImg from '../../assets/images/Holiday.png';

export const UpcomingHolidaysSection = () => {
  const holidayData = [
    { title: 'Republic day', value: '04-05-25', index: 1 },
    { title: 'Republic day', value: '04-05-25', index: 2 },
    { title: 'Republic day', value: '04-05-25', index: 3 },
    { title: 'Republic day', value: '04-05-25', index: 3 },
    { title: 'Republic day', value: '04-05-25', index: 3 },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<PiHouseSimpleBold />}
          heading="Upcoming Holidays"
        />
        <NavLink className={styles.viewAll} to={'calender/schoolcalender'}>
          View All
        </NavLink>
      </div>

      <div className={styles.list}>
        {holidayData.map((item, i) => {
          if (i < 3) {
            return (
              <UpcomingDataCard
                key={i}
                index={item.index}
                title={item.title}
                value={item.value}
                labelType="date"
              />
            );
          }
        })}
      </div>
    </div>
  );
};
